// @ts-strict-ignore
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Icon } from '@node-space/ui-components'
import { useProfileContext } from 'hooks/context/useProfileContext'
import { RoleGroupMatchTypes, useHasRoleGroups } from 'hooks/useHasRoleGroups'
import { ROLES_REQUIRED_TO_ADD_CUSTOMER } from 'pages/Customers/constants'
import { AddCustomer } from './AddCustomer'

export interface AddCustomerCtaProps {
  refetchCustomers: () => void
}

export const AddCustomerCta = ({ refetchCustomers }: AddCustomerCtaProps) => {
  const { t } = useTranslation()
  const [isSheetOpen, setIsSheetOpen] = useState(false)
  const { profile } = useProfileContext()

  const canAddCustomer = useHasRoleGroups(
    profile,
    ROLES_REQUIRED_TO_ADD_CUSTOMER,
    RoleGroupMatchTypes.SOME
  )

  const onOpen = () => {
    if (!canAddCustomer) return
    setIsSheetOpen(true)
  }

  const onClose = () => {
    setIsSheetOpen(false)
  }

  const onCustomerAdded = () => {
    refetchCustomers()
    onClose()
  }

  return (
    <>
      <Button
        onClick={onOpen}
        name={t('customers.addNewCustomer')}
        iconElement={<Icon name="Plus" />}
        disabled={!canAddCustomer}
      >
        {t('customers.addNewCustomer')}
      </Button>
      <AddCustomer isOpen={isSheetOpen} onClose={onClose} onCustomerAdded={onCustomerAdded} />
    </>
  )
}
